import React from 'react';
import cx from 'classnames';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import {Redirect} from 'react-router';
import jwt from 'jsonwebtoken';
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  deleteDashboard,
  fetchDashboardById,
  updateDashboard,
} from '../../actions/dashboard';
import {USER_ROLE} from '../../constants';
import s from './Dashboard.module.scss';
import {Link} from 'react-router-dom';
import {confirmAlert} from 'react-confirm-alert';
import EditorArea from './EditorArea';

class DashboardDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currUser: {},
      redirect: false,
      modalToggleUpdateDashboard: false,
      dashboardContent: {title: '', body: '', highlight: false, role: ''},
      isOpenToast: false
    };
    this.onUpdateDashboard = this.onUpdateDashboard.bind(this);
    this.onChangeUpdateDashboard = this.onChangeUpdateDashboard.bind(this);
    this.toggleUpdateDashboard = this.toggleUpdateDashboard.bind(this);
  }

  /* eslint-disable */
  static propTypes = {
    dashboardDetail: PropTypes.any,
    isFetching: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    message: PropTypes.string
  };
  /* eslint-enable */

  static defaultProps = {
    isFetching: false,
    dashboardDetail: null,
    message: null
  };

  toggleUpdateDashboard() {
    this.setState({
      modalToggleUpdateDashboard: !this.state.modalToggleUpdateDashboard,
    });
  }

  onUpdateDashboard(e) {
    e.preventDefault();
    this.props.dispatch(updateDashboard(this.state.dashboardContent));
    this.toggleUpdateDashboard();
    this.setState({isOpenToast: true})
  }

  onChangeUpdateDashboard(e, name) {
    const fieldName = name || (e && e.target ? e.target.name : null);
    if (!fieldName) return;

    let fieldValue;
    if (e && e.target) {
      fieldValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    } else {
      fieldValue = e;
    }

    this.setState({
      dashboardContent: {
        ...this.state.dashboardContent,
        [fieldName]: fieldValue,
      },
    });
  }

  updateDashboard(item) {
    this.setState({
      dashboardContent: item,
      modalToggleUpdateDashboard: !this.state.modalToggleUpdateDashboard,
    });
  }

  deleteNotification(id) {
    confirmAlert({
      title: 'Xác nhận Xoá',
      message: 'Bạn có chắc muốn xoá thông báo này?',
      buttons: [
        {
          label: 'Có',
          onClick: () => {
            this.props.dispatch(deleteDashboard(id));
            this.setState({redirect: true});
          },
        },
        {
          label: 'Không', onClick: () => {
          }
        },
      ],
    });
  }

  componentDidMount() {
    let {dashboardId} = this.props.match.params;

    let token = localStorage.getItem('id_token');
    let currUser = jwt.decode(token);
    this.setState({currUser: currUser});

    this.props.dispatch(fetchDashboardById(dashboardId));
  }

  render() {
    const {dashboardDetail} = this.props;
    const {redirect} = this.state;

    if (this.props.message && this.state.isOpenToast) {
      toast.error(this.props.message);
      this.setState({isOpenToast: false})
    }

    if (redirect) {
      return <Redirect to='/app/main'/>;
    }
    return (
      <div className={s.root}>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

        {/* Breadcrumbs */}
        <div className={s.breadcrumbContainer}>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/app/main">Thông báo</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Nội dung chi tiết</li>
            </ol>
          </nav>
        </div>

        {/* Detail Header */}
        <div className={s.detailHeader}>
          <Link to="/app/main" className={s.backLink}>
            <i className="fa fa-arrow-left" /> Quay lại danh sách
          </Link>
          <h1>{dashboardDetail?.title || 'Đang tải...'}</h1>
          <div className={s.badge}>
            <i className="fa fa-users mr-1" />
            Đối tượng: {dashboardDetail?.role || 'Tất cả các bộ phận'}
          </div>
        </div>

        <Row>
          <Col md={12}>
            {dashboardDetail && (
              <div className={cx(s.contentCard, { 'border-danger': dashboardDetail?.highlight })}>
                <div className={s.contentTitle}>Nội dung thông báo</div>
                <div className="mb-4" style={{ fontSize: '16px', lineHeight: '1.6', color: '#334155' }}>
                  {ReactHtmlParser(dashboardDetail?.body)}
                </div>

                {(this.state.currUser.role === USER_ROLE.ADMIN || this.state.currUser.role === USER_ROLE.DOCUMENT) && (
                  <div className={s.actionFooter}>
                    <button
                      className={cx(s.btnPremium, s.btnPremiumGroup)}
                      onClick={() => this.updateDashboard(dashboardDetail)}
                    >
                      <i className='fa fa-pencil' /> Chỉnh sửa
                    </button>
                    <button
                      className={cx(s.btnPremium)}
                      style={{ background: '#fee2e2', color: '#ef4444' }}
                      onClick={() => this.deleteNotification(dashboardDetail?.id)}
                    >
                      <i className='fa fa-trash-o' /> Xoá thông báo
                    </button>
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>

        {/* Update content of dashboard */}
        <Modal
          isOpen={this.state.modalToggleUpdateDashboard}
          toggle={this.toggleUpdateDashboard}
          size="lg"
        >
          <ModalHeader>Chỉnh sửa thông báo</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for='title'>Tiêu đề</Label>
              <Input
                value={this.state.dashboardContent.title}
                name='title'
                id='title'
                placeholder='Nhập tiêu đề...'
                onChange={(e) => this.onChangeUpdateDashboard(e)}
              />
            </FormGroup>
            <FormGroup style={{minHeight: '400px'}}>
              <Label for='content'>Nội dung chi tiết</Label>
              <EditorArea
                value={this.state.dashboardContent.body}
                onChange={(e) => this.onChangeUpdateDashboard(e, 'body')}
              />
            </FormGroup>
            
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="roleSelect">Thông báo cho nhóm</Label>
                  <select 
                    id="roleSelect"
                    className="form-control"
                    name='role'
                    value={this.state.dashboardContent.role}
                    onChange={(e) => this.onChangeUpdateDashboard(e)}
                  >
                    <option value="">Tất cả các bộ phận</option>
                    {Object.values(USER_ROLE).map((role) => (
                      <option key={role} value={role}>{role.toUpperCase()}</option>
                    ))}
                  </select>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="d-flex align-items-center h-100 pt-3">
                  <div className="abc-checkbox abc-checkbox-danger">
                    <Input 
                      id="highlightUpdate" 
                      name="highlight" 
                      type="checkbox" 
                      checked={this.state.dashboardContent.highlight}
                      onChange={(e) => this.onChangeUpdateDashboard({ target: { name: 'highlight', value: e.target.checked } })}
                    />
                    <Label for="highlightUpdate">Nổi bật (Quan trọng)</Label>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
             <Button color='success' className="px-4" onClick={(e) => this.onUpdateDashboard(e)}>Lưu thay đổi</Button>
             <Button color='secondary' onClick={this.toggleUpdateDashboard}>Đóng</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

// function TextWithNewLine(props) {
//   const text = props.text;
//   const lines = text.split('\n').map(str => <p>{str || <br />}</p>);
//   return lines;
// }

function mapStateToProps(state) {
  return {
    isFetching: state.dashboard.isFetching,
    dashboardDetail: state.dashboard.dashboardById,
    message: state.dashboard.message
  };
}

export default connect(mapStateToProps)(DashboardDetail);
